import React from 'react';
import loadingSpinner from '../../assets/gif/loading.gif'

type DefaultButtonPropsType = {
  Icon?: React.ElementType;
  buttonText?: string;
  additionalStyle?: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  iconStyle?: string;
  loading?: boolean;
};
const DefaultButton = ({
  Icon,
  buttonText,
  additionalStyle,
  onClick,
  iconStyle,
  disabled = false,
  loading = false
}: DefaultButtonPropsType) => {
  return (
    <button
      disabled={disabled || loading}
      className={`flex items-center gap-1 py-1 border rounded-lg font-semibold ${additionalStyle} max-h-fit justify-center`}
      onClick={onClick}
    >
      {loading ? (
        <img alt='loading' className="w-5 h-5" src={loadingSpinner} />
      ) : (
        <React.Fragment>
          {Icon && <Icon additionalStyle={iconStyle} />}
          {buttonText}
        </React.Fragment>
      )}
    </button>
  );
};

export default DefaultButton;
